import { DEFAULT_HEADERS } from 'src/shared/constants';
import { useEffect, useState } from 'react';

const useChildren = (reFetch: boolean | undefined = undefined) => {
  const [children, setChildren] = useState<any>(undefined);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (token) {
      const getData = async () => {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/children`, {
          method: 'GET',
          headers: {
            ...DEFAULT_HEADERS,
            Authorization: `Bearer ${token}`,
          },
        });
        const jsonData = await response.json();
        setChildren(jsonData);
      };
      getData().then();
    }
  }, [reFetch]);

	const deleteChild = async (childId: number) => {
		return await fetch(`${import.meta.env.VITE_API_URL}/children/${childId}`, {
			method: 'DELETE',
			headers: {
				...DEFAULT_HEADERS,
				Authorization: `Bearer ${token}`,
			},
		});
	}

  return { children, deleteChild };
};

export default useChildren;
